import React from 'react';
import PropTypes from 'prop-types';

import { OptionalElementClickTracker } from '../../../analytics/cohesion';
import Button from '../../Shared/Button';

const PricingSection = ({
  title,
  description,
  buttonText = 'Sign Up',
  buttonVariant = 'primary',
  className = '',
  titleClassName = '',
  descriptionClassName = '',
  buttonClassName = '',
  onClick,
  trackingConfig = null,
}) => {
  return (
    <div
      className={`flex px-0 md:px-30 pt-6 md:pt-12 flex-col justify-center items-center gap-5 self-stretch border-t border-gray-20 ${className}`}
    >
      <h3
        className={`text-xl leading-8 md:leading-6 font-semibold text-gray-90 ${titleClassName}`}
      >
        {title}
      </h3>
      {description && (
        <p
          className={`text-sm leading-5 font-normal text-gray-90 ${descriptionClassName}`}
        >
          {description}
        </p>
      )}
      <OptionalElementClickTracker trackingConfig={trackingConfig}>
        <Button
          variant={buttonVariant}
          size="medium"
          className={`w-full md:w-50 ${buttonClassName}`}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </OptionalElementClickTracker>
    </div>
  );
};

PricingSection.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.string,
  monthlyPrice: PropTypes.string,
  annualPrice: PropTypes.string,
  buttonText: PropTypes.string,
  buttonVariant: PropTypes.string,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  onClick: PropTypes.func,
  trackingConfig: PropTypes.shape({
    actionOutcome: PropTypes.string,
    webElement: PropTypes.shape({
      elementType: PropTypes.string,
      location: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
};

export default PricingSection;
